var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4 py-4 bg-white border border-purple-500 rounded-2xl shadow cursor-pointer transition duration-300 ease-in-out transform hover:-translate-y-1 hover:bg-gray-200",class:{ 'disabled': _vm.disabled },on:{"click":_vm.handleClick}},[_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }